import { defineStore } from "pinia";

import { Station } from "../api/models/station.model";
import { useAuthStore } from "./auth.store";
import { StationGroup } from "../api/models/station-group.model";

export const useStationStore = defineStore('station', {
    state: () => {
        return {
            stations: null as Station[],
            groups: null as StationGroup[],
        };
    },

    getters: {
        allStations(): Station[] {
            let stations: Station[] = this.stations;

            if(!this.stations) {
                return [];
            }

            this.groups?.forEach(grp => {
                const ids = stations.map(s => s.id);
                stations = stations.concat(grp.stations.filter(s => !ids.includes(s.id)))
            });

            return stations.sort((s1, s2) => s2.last_seen - s1.last_seen);
        }
    },

    actions: {
        async fetchStations() {
            const authStore = useAuthStore();
            return this.$stationService.getUserStation()
                .then((stations: Station[]) => {
                    return this.stations = stations.sort((s1, s2) => {
                        if(authStore.favorites.includes(s1.id) && authStore.favorites.includes(s2.id)){
                            return 0;
                        } else if(authStore.favorites.includes(s1.id)) {
                            return -1;
                        } else if(authStore.favorites.includes(s2.id)) {
                            return 1;
                        } else {
                            return 0;
                        }
                    });
                });
        },

        async fetchStationGroups(): Promise<StationGroup[]> {
            const groups: StationGroup[] = await this.$stationService.getUserGroups();

            await Promise.all(groups.map(grp => this.$stationService.getStationsByGroup(grp.name)))
                .then((stationsByGroup: Station[][]) => {
                    stationsByGroup.forEach((stations: Station[], index: number) => {
                        if(groups[index]) {
                            groups[index].stations = stations;
                            groups[index].stations.sort((s1,s2) => s2.last_seen - s1.last_seen);
                        }
                    })
                });

            return this.groups = groups;
        },

        async refresh(): Promise<void> {
            await this.fetchStations();
            await this.fetchStationGroups();
        },
        
        async pairStation(pairingToken: string): Promise<Station> {
            const result = await this.$stationService.pairStation(pairingToken);
            await this.fetchStations();
            return result;
        },
        
        async forgetStation(station: Station): Promise<void> {
            await this.$stationService.forgetStation(station);
            await this.fetchStations();
        },
        
        async updateStation(stationId: string, station: Partial<Station>): Promise<Station> {
            const result = await this.$stationService.updateStation(stationId, station);
            await this.fetchStations();
            return result;
        },
    }
})